import { LazyTranslationsLoader } from './registerLazyTranslations.types';

export const lazyTranslationsRegistry = new Map<
  string,
  LazyTranslationsLoader
>();

const registerLazyTranslations = (
  ns: string,
  loader: LazyTranslationsLoader,
) => {
  if (
    process.env['NODE_ENV'] !== 'production' &&
    lazyTranslationsRegistry.has(ns)
  ) {
    console.warn(
      `i18n: duplicate registerLazyTranslations for namespace "${ns}" — the previous loader will be overwritten.`,
    );
  }

  lazyTranslationsRegistry.set(ns, loader);
};

export default registerLazyTranslations;
